export const PAYMENT_LINK_APIS = {
  generate_payment_link: "payments/exly/link/generate",
  update_payment_link: "payments/exly/link/update",
  validate_payment_link: "payments/validate/link/generation",
};
export const CREATE_COMBO_PAYMENT_LINK = "payments/exly/link/generate/combo";
export const FETCH_PAYMENT_LINK = "payments/exly/dynamiclink";